export default __webpack_public_path__ + "static/media/LUNA.cabcfcb3.svg";